import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.scss';

const FrayedEdge = ({ color = 'turquoise', bottom = false }) => (
  <div className={`${styles['frayed-edge']} ${styles[`frayed-edge--${color}`]}`} />
);

FrayedEdge.propTypes = {
  color: PropTypes.string,
  bottom: PropTypes.bool,
};

export default FrayedEdge;
